<template>
 	<div class="d-flex flex-1 h-100 overflow-auto">
    	<v-card class="report-container w-100 p-0" style="border-radius: 12px; margin-bottom: 24px">
			<v-toolbar class="shadow-none" style="flex: unset" content-class="h-auto">
				<div class="custom-icon-wrapper">
					<v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
				</div>
				<v-toolbar-title class="size-16 dark-text">{{ $t("res_Label_ManageWorkflows") }}</v-toolbar-title>
			</v-toolbar>
			<div class="border-top p-4 flex-1 overflow-auto">
				<div class="row align-items-start flex-nowrap m-0 gap-2" style="flex: unset">
					<div class="col-md-4 p-0">
						<v-label>{{ $t("res_Label_SearchforWorkflow") }}</v-label>
						<v-text-field v-model="search_query" label="" solo></v-text-field>
					</div>
					<div class="col-md-4 p-0 h-100">
						<div class="d-flex gap-2 h-100 align-items-end">
							<v-btn color="light-blue" dense @click="clearFields()">{{ $t("res_ButtonText_Clear") }}</v-btn>
							<v-btn color="primary" dense @click="Search(true)">{{ $t("res_ButtonText_Search") }}</v-btn>
							<v-btn color="primary" @click="Add()">{{ $t("res_ButtonText_Add") }}</v-btn>
						</div>
					</div>
				</div>

				<Pagination class="mb-2" :totalCount="pagingData.totalCount" :pageSize="pagingData.pageSize" :pageIndex="pagingData.pageIndex" 
					@pageIndexChanged="pageIndexChanged"></Pagination>

				<div class="d-flex flex-1 flex-column overflow-auto mt-2">
					<v-data-table :mobile-breakpoint="0" class="position-relative white flex-1 d-flex overflow-auto" disable-sort 
						:headers="headers" :items="Workflow_items" :loading="loading" loading-text="loading..."
						:no-data-text="$t('res_Label_NoData')" :footer-props="{ 'items-per-page-text': 'Items per page' }" caption="" hide-default-footer
						header-fixed :class="{ 'no-data': Workflow_items.length == 0 }" :items-per-page="pagingData.pageSize">
						<template v-slot:no-data>
							<div>
								<img style="width: 118px" src="/assets/images/empty-inbox.svg" alt="" />
								<p class="m-0">{{ $t("res_No_new_items_here") }}</p>
							</div>
						</template>
						<template v-slot:item="row">
							<tr>
								<td>{{ row.item.name }}</td>
								<td class="text-start">
									<div class="onhover-display">
										<div class="custom-icon-wrapper">
											<v-icon v-tooltip.hover="$t('Update')" @click="GetRecord(row.item.id)">custom-icon white-bg edit-icon</v-icon>
										</div>
										<div v-if="false" class="custom-icon-wrapper">
											<v-icon v-tooltip.hover="$t('res_ButtonText_Delete')" @click="DeleteRecord(row.item.id, row.item.hasSteps)">custom-icon white-bg delete-icon</v-icon>
										</div>
									</div>
								</td>
							</tr>
						</template>
					</v-data-table>
				</div>
      		</div>
    	</v-card>

		<v-dialog v-model="upsertWorkflowDialog" :fullscreen="WorkflowFormIsFullScreen" width="1400" height="600" style="overflow: hidden !important" :content-class="MainDialogClass">
			<v-card>
				<v-toolbar class="bg-white">
					<v-card-title class="p-0">{{ $t("res_DialogTitle_AddEditWorkflow") }}</v-card-title>
					<v-spacer></v-spacer>
					<v-btn class="close-btn light-btn" icon dark @click="upsertWorkflowDialog = false"><v-icon>mdi-close</v-icon></v-btn>
				</v-toolbar>
				<v-row align="start" class="p-3" :style="WorkflowInputsStyle">
					<v-col cols="3">
						<v-label>{{ $t("res_Label_NameEn") }} *</v-label>
						<v-text-field maxlength="50" v-model="Workflow.nameEn" label="" solo></v-text-field>
					</v-col>
					<v-col cols="3">
						<v-label>{{ $t("res_Label__NameAr") }} *</v-label>
						<v-text-field maxlength="50" v-model="Workflow.nameAr" label="" solo></v-text-field>
					</v-col> 
					<v-col cols="3" id="ManageWorkflow-CategoryDiv">  
							<v-label>{{ $t("res_Label_Category") }} *</v-label> 
							<multi-select class="light-bg add-arrow" v-model="categoriesSelected" label="name"  track-by="id"
									open-direction="bottom" :options="categoriesForSelection" :searchable="false" :internal-search="false"
									:clear-on-select="false" :close-on-select="false" :options-limit="300" 
									:max-height="600" :show-no-results="false" :hide-selected="false" :multiple="true" ref="multiselect2">
							</multi-select> 
					</v-col> 
					<v-col cols="3">  
							<v-label>{{ $t("res_Label_AvailableForAll") }}</v-label>
							<v-checkbox class="mt-0" v-model="Workflow.availableForAll"></v-checkbox>
					</v-col>
				</v-row> 
				<div v-show="ShowSteps && ShowAddSteps" class="pl-4 pr-4 mt-4" style="display: flex; justify-content: flex-end">  
					<v-btn class="primary btn-sm ml-1 mr-1" style="min-width: 70px !important" @click="Steps_Add()">{{ $t("res_ButtonText_New") }}
					</v-btn>
				</div>
				<v-row v-show="ShowSteps" class="p-3 mt-0" style="height: 320px">
					<v-col cols="12" style="height: 320px">	
						<Pagination class="" :totalCount="StepsPagingData.totalCount" style="padding-bottom: 5px;"
							:pageSize="StepsPagingData.pageSize" :pageIndex="StepsPagingData.pageIndex" @pageIndexChanged="StepsPageIndexChanged"></Pagination>
						
						<v-data-table style="height: 320px" :mobile-breakpoint="0" class="position-relative white flex-1 d-flex overflow-auto" 
							disable-sort :headers="Steps_Headers" :items="Workflow_Step_items" :loading="StepsLoading" loading-text="loading..."
							:no-data-text="$t('res_Label_NoData')" :footer-props="{ 'items-per-page-text': 'Items per page' }" caption="" hide-default-footer
							header-fixed :class="{ 'no-data': Workflow_Step_items.length == 0 }" :items-per-page="StepsPagingData.pageSize">
							<template v-slot:no-data>
								<div>
									<img style="width: 118px" src="/assets/images/empty-inbox.svg" alt="" />
									<p class="m-0">{{ $t("res_No_new_items_here") }}</p>
								</div>
							</template>
							<template v-slot:item="row">
								<tr>
									<td>{{ row.item.name }}</td>
									<td>{{ row.item.advanceStepName }}</td>
									<td>{{ row.item.rejectStepName }}</td>
									<td>{{ row.item.canSign == true ? $t("res_ButtonText_Yes") : $t("res_ButtonText_No") }}</td>
									<td>{{ row.item.canTransfer == true ? $t("res_ButtonText_Yes") : $t("res_ButtonText_No") }}</td>
									<td>{{ row.item.canVote == true ? $t("res_ButtonText_Yes") : $t("res_ButtonText_No") }}
									</td>
									<td class="text-start">
										<div class="onhover-display">
											<div class="custom-icon-wrapper">
												<v-icon v-tooltip.hover="$t('Update')" @click="Steps_GetRecord(row.item.id)">
													custom-icon white-bg edit-icon
												</v-icon>
											</div>
											<div class="custom-icon-wrapper">
												<v-icon v-tooltip.hover="$t('res_ButtonText_Delete')" @click="Steps_Delete(row.item.id, row.item.hasSteps)">
													custom-icon white-bg delete-icon
												</v-icon>
											</div>
										</div>
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
				<v-card-actions class="gap-2 sticky-actions shadow-none">
					<v-spacer></v-spacer>
					<v-btn class="primary" style="min-width: 100px !important" @click="upsertWorkflowVotesForm = true">{{ $t("res_ButtonText_DefineVotes") }}</v-btn>
					<v-btn class="light-blue" style="min-width: 100px !important" @click="closeupsertWorkflowDialog()">{{ $t("res_ButtonText_Cancel") }}</v-btn>  
					<v-btn class="primary" style="min-width: 100px !important" @click="upsert()">{{ $t("res_ButtonText_Continue") }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="upsertWorkflowVotesForm" content-class="VotesForm" persistent>
			<v-card class="p-1">
				<div class="row">
					<div class="col-12 p-3">
						<div class="mt-3 row" id="VotesFormTitleDiv"> 
							<div class="col-1" style="margin:auto">
								<label class="label_required mr-auto font-weight-bold">{{ $t("res_ButtonText_Votes") }}</label>
							</div>
							<div class="col-8 text-center" style="margin:auto">
								<label v-show="currentVotes == null || currentVotes.length == 0" class="label_required mr-auto" style="font-size: 15px;">{{ $t("res_Label_Votes") }}</label>
							</div>
							<div class="col-3 text-end">
								<v-btn class="primary btn-sm" style="min-width: 70px !important" @click="addVote">
								{{ $t("res_ButtonText_New") }}
								</v-btn>
							</div> 
						</div>
						<div id="votesContainer" class="pl-3 pr-3 pt-1">
							<div class="d-flex align-items-center" v-for="(vote, idx) in currentVotes" :key="idx">
								<v-text-field v-model="vote.textEn" :placeholder="$t('res_Label_EnValue')" solo />
								<v-text-field v-model="vote.textAr" :placeholder="$t('res_Label_ArValue')" solo  />  
								<a @click="removeVote(idx)" v-tooltip.hover="$t('res_ButtonText_Delete')" class="custom-table-icon" style="padding-top:1% !important">
									 <span class="mdi mdi-trash-can" style="font-size: 20px"></span>
								</a>
							</div>
						</div>
					</div>
				</div>
				<v-row class="m-0 pr-1 pl-1"> 
					<v-col cols="4" class="text-start">
						<v-btn v-show="currentVotes != null && currentVotes.length > 0"  class="light-blue btn-sm ml-1 mr-1" style="min-width: 70px !important" @click="clearVotes">
							{{ $t("res_ButtonText_Clear") }}
						</v-btn> 
						<v-btn v-show="currentVotes != null && currentVotes.length > 0" class="primary btn-sm ml-1 mr-1" style="min-width: 70px !important" @click="saveVotes">
							{{ $t("res_ButtonText_Save") }}
						</v-btn> 
					</v-col>
					<v-col cols="8" class="text-end"> 
						<v-btn class="light-blue btn-sm ml-1 mr-1" style="min-width: 70px !important" @click="upsertWorkflowVotesForm = false">
							{{ $t("res_ButtonText_Close") }}
						</v-btn>
					</v-col>
				</v-row>
			</v-card>
		</v-dialog> 

		<v-dialog v-model="upsertWorkflowStepsForm" content-class="fullscreen-dialog" persistent>
			<v-card class="p-1">
				<v-row class="p-2 rounded StepsDiv">
					<v-col cols="12">
						<v-label>{{ $t("res_Label_StepName") }}</v-label>
						<v-text-field maxlength="50" v-model="WorkflowStep.name" label="" solo max="100"></v-text-field>
					</v-col>
					<hr />
					<v-col cols="3">
						<v-label>{{ $t("res_Label_Purpose") }}</v-label>
						<v-select v-model="purpose" :items="purposes" item-text="name" item-value="id" label="" solo return-object></v-select>
					</v-col> 
					<v-col cols="3">
						<v-label>{{ $t("res_Label_CompletionCriteria") }}</v-label>
						<v-select class="mb-4" v-model="completionCriteria" :items="completionCriteriaOptions" item-text="name" item-value="id" label="" solo return-object></v-select>
						<span class="percentager">
							<!-- removed the below option only for ADGM case -->
							<!-- && completionCriteria.id == 3 -->
							<v-label v-if="completionCriteria != undefined">{{ $t("res_Label_Percentage") }}</v-label>
							<v-text-field  id="percentager" @input="checkPercentage" label="" v-if="completionCriteria != undefined" 
								v-model="percentager" type="number" solo max="100"></v-text-field>
						</span> 
					</v-col>
					<v-col cols="3">
						<v-label>{{ $t("res_Label_StepAdvance") }}</v-label>
						<v-select v-model="advanceStep" :items="advanceSteps" :disabled="disabledAdvanceSteps" item-text="name" item-value="id" 
							label="" solo return-object @change="ArrangeAdvanced_Reject_Selects"></v-select>
						
						<div v-if="advanceStep != undefined && advanceStep.id == '0'">
							<div class="text-center pt-4">
								<label class="font-italic mt-2 mb-2">
									On advance workflow, do the following
								</label>
							</div>
							<div>
								<v-row class="mb-3">
									<v-col rows="6" class="p-0 d-flex align-center justify-center">
									    <v-checkbox label="Complete & End" v-model="Advance_CompleteEndCheckBox" @change="onChange_Advance_ValueAfterAdvance(1)">
										</v-checkbox>  
									</v-col> 
									<v-col rows="6" class="p-0 d-flex align-center justify-center">
										<v-checkbox label="Archive & End" v-model="Advance_ArchiveEndCheckBox" @change="onChange_Advance_ValueAfterAdvance(2)">
										</v-checkbox>  
									</v-col> 
								</v-row>
							</div>
						</div>
					</v-col> 
					<v-col cols="3">
						<v-label>{{ $t("res_Label_Reject") }}</v-label>
						<v-select v-model="rejectStep" :items="rejectSteps" :disabled="disabledRejectSteps"
							item-text="name" item-value="id" label="" solo return-object @change="ArrangeAdvanced_Reject_Selects">
						</v-select>
						<div v-if="rejectStep != undefined && rejectStep.id == '0'"> 
							<div class="text-center pt-4">
								<label class="font-italic mt-2 mb-2">
									On reject workflow, do the following
								</label>
							</div> 
							<div>
								<v-row class="mb-3">
									<v-col rows="6" class="p-0 d-flex align-center justify-center">
									    <v-checkbox label="Complete & End" v-model="Reject_CompleteEndCheckBox" @change="onChange_Reject_ValueAfterAdvance(1)">
										</v-checkbox>  
									</v-col> 
									<v-col rows="6" class="p-0 d-flex align-center justify-center">
										<v-checkbox label="Archive & End" v-model="Reject_ArchiveEndCheckBox" @change="onChange_Reject_ValueAfterAdvance(2)">
										</v-checkbox>  
									</v-col> 
								</v-row>
							</div>
						</div>
					</v-col>
					<hr />
					<v-col cols="6">
							<v-label>{{ $t("res_Label_To") }}</v-label>
						<div class="row">
							<div class="col-3">
								<v-label>{{ $t("res_Label_UserStructure") }}</v-label>
								<v-checkbox class="mt-0" @change="checkToUser_TO" :disabled="disabledIsStart" v-model="to.user"></v-checkbox>
							</div>
							<div class="col-2">
								<v-label>{{ $t("res_Label_Custom") }}</v-label>
								<v-checkbox class="mt-0" @change="checkCustomTO" v-model="to.custom"></v-checkbox>
							</div>
							<div class="col-2">
								<v-label>{{ $t("res_Label_Group") }}</v-label>
								<v-checkbox @change="checkGroupTo()" class="mt-0" v-model="to.group"></v-checkbox>
							</div>
						</div>
						<div :class="ToUser_DivClass" v-if="to.user">
							<div class="row">
								<div class="col-3 col-3 m-auto">{{ $t("res_Label_ٍSelectUser-Structure") }}</div>
								<div class="col-9">
									<StructureUserSelector :showInternalUsers="true" :showInternalStructures="true" :showExternalStructures="false" :excludeSelf="true"
										:isMultiple="true"  :selectedStructureUsersList="ToUser_TO" @structureUserSelectChanged="userSelectChanged_TO">
									</StructureUserSelector>
								</div>
							</div>
						</div>
						<div class="To_CC_Select_Div row" v-if="to.custom">
							<div class="col-3 col-3 m-auto">{{ $t("res_Label_SelectCustom") }}</div>
							<div class="col-9">
								<multi-select class="light-bg add-arrow" v-model="CustomTO" label="name" placeholder="Select" track-by="id" open-direction="bottom" 
									:options="CustomItems" :searchable="false" :internal-search="false" :clear-on-select="false" :close-on-select="false" 
									:options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="true" ref="multiselect2">
								</multi-select>
							</div>
						</div>
						<div class="row" v-if="to.group">
							<div class="col-3 col-3 m-auto">{{ $t("res_Label_EntityGroup") }}</div>
							<div class="col-9">
								<v-select  :items="groupEntites"  v-model="groupEntityTo" 
									item-text="name" item-value="id" label="" solo return-object >
								</v-select>
							</div>
						</div>
					</v-col>
					<v-col cols="6">
						<div class="row">
							<v-label>{{ $t("res_Label_CC") }}</v-label>
							<div class="col-3">
								<v-label>{{ $t("res_Label_UserStructure") }}</v-label>
								<v-checkbox class="mt-0" @change="checkToUser_CC"  :disabled="disabledIsStart" v-model="cc.user"></v-checkbox>
							</div>
							<div class="col-2">
								<v-label>{{ $t("res_Label_Custom") }}</v-label>
								<v-checkbox class="mt-0" @change="checkCustomTO" v-model="cc.custom"></v-checkbox>
							</div>
							<div class="col-2">
								<v-label>{{ $t("res_Label_Group") }}</v-label>
								<v-checkbox class="mt-0" @change="checkGroupCC" v-model="cc.group"></v-checkbox>
							</div>
						</div>
						<div :class="CCUser_DivClass" v-if="cc.user">
							<div class="row">
								<div class="col-3 col-3 m-auto">{{ $t("res_Label_ٍSelectUser-Structure") }}</div>
								<div class="col-9">
									<StructureUserSelector :showInternalUsers="true" :showInternalStructures="true" :showExternalStructures="false" :excludeSelf="true" 
										:isMultiple="true" :selectedStructureUsersList="ToUser_CC" @structureUserSelectChanged="userSelectChanged_CC">
									</StructureUserSelector>
								</div>
							</div>
						</div>
						<div class="row" v-if="cc.custom">
							<div class="col-3 col-3 m-auto">
								{{ $t("res_Label_SelectCustom") }}
							</div>
							<div class="col-9">
								<multi-select class="light-bg add-arrow" v-model="CustomCC" label="name" placeholder="Select" track-by="id"
									open-direction="bottom" :options="CustomItems" :searchable="false" :internal-search="false"
									:clear-on-select="false" :close-on-select="false" :options-limit="300" 
									:max-height="600" :show-no-results="false" :hide-selected="false" :multiple="true" ref="multiselect2">
								</multi-select>
							</div>
						</div>
						<div class="row" v-if="cc.group">
							<div class="col-3 col-3 m-auto">{{ $t("res_Label_EntityGroup") }}</div>
							<div class="col-9">
								<v-select  :items="groupEntites"  v-model="groupEntityCC" 
									item-text="name" item-value="id" label="" solo return-object >
								</v-select>
							</div>
						</div>
					</v-col>
					<hr />
					<v-col cols="12" class="row mt-3">
						<div class="col-2">
							<v-label>{{ $t("res_Label_IsStart") }}</v-label>
							<v-checkbox class="mt-0" :disabled="disabledIsStart" v-model="WorkflowStep.isStart"></v-checkbox>
						</div>
						<div class="col-2">
							<v-label>{{ $t("res_Label_CanSign") }}</v-label>
							<v-checkbox class="mt-0" v-model="WorkflowStep.canSign"></v-checkbox>
						</div>
						<div class="col-2">
							<v-label>{{ $t("res_Label_CanTransfer") }}</v-label>
							<v-checkbox class="mt-0" v-model="WorkflowStep.canTransfer"></v-checkbox>
						</div>
						<div class="col-2">
							<v-label>{{ $t("res_Label_CanVote") }}</v-label>
							<v-checkbox class="mt-0" v-model="WorkflowStep.canVote"></v-checkbox>
						</div>
						<div class="col-2">
							<v-label>{{ $t("res_Label_CanSeeVotingResults") }}</v-label>
							<v-checkbox class="mt-0" v-model="WorkflowStep.canSeeVotingResults"></v-checkbox>
						</div>
					</v-col>
				</v-row>

				 <v-card-actions class="gap-2 sticky-actions" style="box-shadow:none">
						<v-row v-show="ShowSteps && ShowSaveSteps" class="pr-1 pl-1">
							<v-col cols="3" class="offset-9 text-end">
								<v-btn class="primary btn-sm" style="min-width: 70px !important" @click="StepsCloseupsertWorkflowDialog()">
									{{ $t("res_ButtonText_Cancel") }}
								</v-btn>
								<v-btn :class="cancelFormClass" style="min-width: 70px !important" @click="Steps_upsert()">
									{{ $t("res_ButtonText_Save") }}
								</v-btn>
							</v-col>
						</v-row>
				 </v-card-actions> 
			</v-card>
		</v-dialog>
  	</div>
</template>

<script>
import axios from "axios";
import router from "@/router/index.js";
import constants from "@/assets/js/constants";
import MultiSelect from "vue-multiselect";
import Pagination from "@/components/Pagination.vue";
import StructureUserSelector from "@/components/StructureUserSelector.vue";

export default {
	name: "ManageWorkflows",
	components: { MultiSelect, Pagination, StructureUserSelector },
	data: function () {
		return {  
			Reject_CompleteEndCheckBox: false,
            Reject_ArchiveEndCheckBox: false,
			Advance_CompleteEndCheckBox: false,
            Advance_ArchiveEndCheckBox: false, 
			AdvancedCompleteArchiveChecked: false,
			categoriesSelected: [{ id: 0, name: "" }],
			categoriesForSelection: [{ id: 0, name: "" }],
			percentager:0,
			to:{
				user:true,
				custom:false,
				group:false
			},
			cc:{
				user:true,
				custom:false,
				group:false
			},
			groupEntites:[],
			groupEntityTo:{},
			groupEntityCC:{},
			upsertWorkflowVotesForm: false,
			currentVotes: [],
			MainDialogClass: "smaller-dialog",
			ToUser_DivClass: "StructureUserDiv",
			CCUser_DivClass: "StructureUserDiv",
			CustomCC: [{ id: 0, name: "" }],
			CustomTO: [{ id: 0, name: "" }],
			disabledIsStart: false,
			WorkflowInputsStyle: "margin-bottom:0px",
			WorkflowFormIsFullScreen: false,
			CustomItems: [
				{ id: "Manager", name: "Manager" },
				{ id: "Initiator", name: "Initiator" }
			],
			CustomUserEnum: {
				Manager: "Manager",
				Recipient: "Recipient",
			},
			ToTypeSelectionEnum: { User: 1, Custom: 3 },
			purpose: {},
			advanceStep: {},
			rejectStep: {},
			purpose: {},
			cancelFormClass: "",
			upsertWorkflowStepsForm: false,
			ToUser_TO: { type: Array, default: [] },
			ToUser_CC: { type: Array, default: [] },
			Strucutreslbl: "",
			Userlbl: "",
			Customlbl: "",
			ShowAddSteps: true,
			ShowSaveSteps: false,
			ShowSteps: false,
			StepsLoading: false,
			loading: false,
			search_query: "",
			All_Workflow_items: [],
			Workflow_items: [],
			All_Workflow_Step_items: [],
			Workflow_Step_items: [],
			company_items: [],
			userId: 0,
			manageApplicationRoleDialog: false,
			options: ["list", "of", "options"],
			Steps_Headers: [
				{ text: this.$t("res_GridHeaders_Name"), value: "", width: "160px", class: "text-centerC" },
				{ text: this.$t("res_Label_StepAdvance"), value: "", width: "160px", class: "text-centerC" },
				{ text: this.$t("res_Label_Reject"), value: "", width: "160px", class: "text-centerC" },
				{ text: this.$t("res_Label_CanSign"), value: "", width: "160px", class: "text-centerC" },
				{ text: this.$t("res_Label_CanTransfer"), value: "", width: "160px", class: "text-centerC" },
				{ text: this.$t("res_Label_CanVote"), value: "", width: "160px", class: "text-centerC" },
				{ text: "", value: "actions", sortable: false, width: "190px" },
			],
			headers: [
				{ text: this.$t("res_GridHeaders_Name"), value: "" },
				{ text: "", value: "actions", sortable: false, width: "190px" },
			],
			upsertWorkflowDialogMode: "new",
			upsertWorkflowDialog: false,
			privacies: [],
			contactRoles: [],
			Workflow: {
				nameEn: "",
				nameAr: "",
				availableForAll: false,
				categories: "",
			},
			WorkflowStep: {
				userId: null,
				purposeId: null,
				custom: "",
				canTransfer: false,
				canVote: false,
				canSeeVotingResults: false,
				canSign: false,
				name: "",
				workflowId: null,
				rejectStepId: null,
				advanceStepId: null,
				completeAndEndAfterAdvance: false,
				archiveAndEndAfterAdvance: false,
				completeAndEndAfterReject: false,
				archiveAndEndAfterReject: false
			},
			pagingData: {
				pageSize: 10,
				pageIndex: 0,
				totalCount: 0,
			},
			StepsPagingData: {
				pageSize: 10,
				pageIndex: 0,
				totalCount: 0,
			},
			purposes: [],
			completionCriteria:{id:0,name:""},
			completionCriteriaOptions: [
				{ id: 1, name: "All To Complete" },
				{ id: 2, name: "One To Complete" },
				{ id: 3, name: "Percentage To Complete" },
			],
			steps: [],
			advanceSteps: [],
			rejectSteps: [],
			disabledAdvanceSteps: false,
			disabledRejectSteps: false,
			radioGroupValueAfterAdvance: null,
			radioGroupValueAfterReject: null
		};
	},
	methods: 
	{
		onChange_Reject_ValueAfterAdvance(value) {  
			this.radioGroupValueAfterReject = value; 
			  if (checkedValue === 1 && this.Reject_CompleteEndCheckBox) {
                this.Reject_ArchiveEndCheckBox = false;
            } else if (checkedValue === 2 && this.Reject_ArchiveEndCheckBox) {
                this.Reject_CompleteEndCheckBox = false;
            } 
    	},
		onChange_Advance_ValueAfterAdvance(value) {  
			this.radioGroupValueAfterAdvance = value; 
			  if (checkedValue === 1 && this.Advance_CompleteEndCheckBox) {
                this.Advance_ArchiveEndCheckBox = false;
            } else if (checkedValue === 2 && this.Advance_ArchiveEndCheckBox) {
                this.Advance_CompleteEndCheckBox = false;
            } 
    	},
		checkPercentage()
		{
			if (this.percentager > 100)
			{
				window.showAlert(this.$t("res_Msgs_Percentage"), "warning");
				this.percentager = null;
			} 
		},
		checkGroupTo()
		{
			if (this.to.group == false)
				this.groupEntityTo = {}
		},
		checkGroupCC()
		{
			if (this.cc.group==false)
				this.groupEntityCC = {}
		},
		checkCustomCC(){
			if (this.cc.custom == false)
				this.CustomCC = {}
		},
		checkCustomTO()
		{
			if (this.to.custom == false)
				this.CustomTO = {}
		},
		checkToUser_TO()
		{
			if (this.to.user == false)
				this.ToUser_TO=[]
		},
		checkToUser_CC()
		{
			if (this.cc.user == false)
				this.ToUser_CC = []
		},
		getEntitiesGroup()
		{
			axios.get(constants.baseApiUrl +`Admin/GetEntitiesGroup`)
				.then((res) => this.groupEntites = res.data)
				.catch((err) => console.warn(err));
		},
		removeVote(indexToRemove) 
		{
			this.currentVotes = this.currentVotes.filter((_, i) => i !== indexToRemove);
			this.Workflow.votes = this.currentVotes;
		},
		addVote() 
		{
			this.currentVotes.push({ textEn: "", textAr: "" });
		},
		handleSelectElement(data, tempItem) 
		{
			if (data.length > 0) 
			{
				let shouldAddTemp = true;
				for (let i = 0; i < data.length; i++) 
				{
					if (data[i].isTemp || data[i].id == undefined || data[i].id == null) 
					{
						shouldAddTemp = false;
						break;
					}
				}
				if (shouldAddTemp) 
				{
					if (tempItem == undefined || tempItem == null) 
					{
						tempItem = { isTemp: true, name: "temp" };
					}
					data = [tempItem, ...data];
				} 
				else if (data.length == 1) 
				{
					data = [];
				}
			}
			return data;
		},
		userSelectChanged_TO(items) 
		{
			this.ToUser_TO = this.handleSelectElement(items, { name: "temp", isTemp: true });
			this.FixSelectLabel_TO();
		},
		userSelectChanged_CC(items) 
		{
			this.ToUser_CC = this.handleSelectElement(items, { name: "temp", isTemp: true});
			this.FixSelectLabel_CC();
		},
		Search: function (
			isResetPaging,
			PaginationTriggered = false,
			PageNumber = 0,
			PageSize = 10
		) {
			if (isResetPaging) {
				this.pagingData.totalCount = 0;
				this.pagingData.pageIndex = 0;
			}

			if (PaginationTriggered == false) {
				axios
					.get(
						constants.baseApiUrl +
							`Workflow/GetWorkflows?lang=${localStorage.getItem(
								"lang"
							)}&SearchTerm=${this.search_query.trim()}`
					)
					.then((res) => {
						this.All_Workflow_items = res.data;
						this.Workflow_items = res.data;
						this.pagingData.totalCount = res.data.length;
					})
					.catch((err) => console.warn(err));
			} else {
				let startIndex = PageNumber * PageSize;
				this.Workflow_items = this.All_Workflow_items.slice(
					startIndex,
					startIndex + PageSize
				);
			}
		},
		BindSteps: function (
			WorkflowId,
			isResetPaging,
			PaginationTriggered = false,
			PageNumber = 0,
			PageSize = 10
		) {
			this.ShowSaveSteps = false;
			this.ShowAddSteps = true;
			this.upsertWorkflowStepsForm = false;

			if (isResetPaging) {
				this.pagingData.totalCount = 0;
				this.pagingData.pageIndex = 0;
			}
			if (PaginationTriggered == false) {
				axios
					.get(
						constants.baseApiUrl +
							`Workflow/Steps/${WorkflowId}/GetWorkflowSteps?lang=${localStorage.getItem(
								"lang"
							)}`
					)
					.then((res) => {
						this.All_Workflow_Step_items = res.data;
						this.Workflow_Step_items = res.data;
						this.StepsPagingData.totalCount = res.data.length; 
						this.BindStepFormData(res.data);
					})
					.catch((err) => console.warn(err));
			} else {
				let startIndex = PageNumber * PageSize;
				this.Workflow_Step_items = this.All_Workflow_Step_items.slice(
					startIndex,
					startIndex + PageSize
				);
			}
		},
		backToAdminPage() {
			router.push({ name: "admin" });
		},
		clearFields() {
			this.search_query = "";
			this.Search();
		},
		clearInputs() 
		{
			this.Workflow.id = 0;
			this.Workflow.nameEn = "";
			this.Workflow.nameAr = "";
			this.Workflow.availableForAll = false;
			this.Workflow.categories = ""; 
			this.categoriesSelected= [{ id: 0, name: "" }];
		},
		Add() 
		{
			this.WorkflowFormIsFullScreen = false;
			this.MainDialogClass = "smaller-dialog";
			this.WorkflowInputsStyle = "margin-bottom:0px";
			this.upsertWorkflowDialogMode = "new";
			this.upsertWorkflowDialog = true;
			this.ShowSteps = false;
			this.clearInputs();
			this.clearVotes();
		},
		GetRecord(id, item = null) {
			this.clearInputs();
			this.ShowSteps = true;
			this.WorkflowFormIsFullScreen = true;
			this.MainDialogClass = "fullscreen-dialog";
			this.WorkflowInputsStyle = "margin-bottom:-120px";
			if (item == null) {
				axios
					.get(constants.baseApiUrl + `Workflow/GetWorkflow/${id}`)
					.then((res) => { 
						this.Workflow = res.data;  
						let bindedCategories = res.data.categories ? res.data.categories.split(",").map(item => parseInt(item, 10)) : [];
						this.Workflow.categories = bindedCategories.length == 0 ? '' : res.data.categories;
						this.categoriesSelected =  bindedCategories.length == 0 ? [] : [ { id: 0, name: "" }, ...this.categoriesForSelection.filter(s=> bindedCategories.includes(s.id)), ]; 
						  
						if (
							res.data &&
							res.data.votes &&
							res.data.votes.length > 0
						) {
							this.currentVotes = res.data.votes;
						}
						else {this.clearVotes();}
						this.upsertWorkflowDialogMode = "edit";
						this.upsertWorkflowDialog = true;
						this.BindSteps(id, false);
					})
					.catch((err) => console.warn(err));
			} else { 
				this.Workflow = item; 
				let bindedCategories =  item  .categories ?  item  .categories.split(",").map(item => parseInt(item, 10)) : [];
				this.Workflow.categories = bindedCategories.length == 0 ? '' :  item  .categories;
				this.categoriesSelected =  bindedCategories.length == 0 ? [] : [ { id: 0, name: "" }, ...this.categoriesForSelection.filter(s=> bindedCategories.includes(s.id)), ];  
				this.upsertWorkflowDialogMode = "edit";
				this.upsertWorkflowDialog = true;
				this.BindSteps(item.id, false);
			}
		},
		DeleteRecord(id, hasRelatedSteps = false) {
			if (hasRelatedSteps == true) {
				window.showInformation(
					this.$t("res_Label_Alert"),
					this.$t("res_Msgs_DeleteWorkflowAlert"),
					() => {this.Delete(id)},
					() => {}
				);
			} else {
				this.Delete(id);
			}
		},
		Delete(id) {
			axios
				.delete(constants.baseApiUrl + `Workflow/DeleteWorkflow/${id}`)
				.then((res) => {
					window.showAlert(
						this.$t("res_Msgs_FilingOrClassificationDeleted"),
						"success"
					);
					this.Search(true);
				})
				.catch((err) => console.warn(err));
		},
		upsert() 
		{ 
            this.Workflow.categories = 
				this.categoriesSelected.length == undefined || this.categoriesSelected.length == 0 ? "" : 
				this.categoriesSelected.filter((item) => item.id != "0").map((item) => item.id).join(","); 
			
			var isFormValid = true;
			isFormValid = this.Workflow.nameAr.trim() != "" &&
				this.Workflow.nameEn.trim() != "" && this.Workflow.categories != '';

			if (isFormValid == false) 
			{
				window.showAlert(this.$t("res_Msgs_FillRequired"), "warning");
				return;
			}

			axios.post(constants.baseApiUrl + "Workflow/SaveWorkflow", this.Workflow)
				.then((res) => 
				{
					if (res.data.success == true) 
					{
						window.showAlert(this.$t("res_Msgs_SuccessfulSave"), "success"); 
						this.clearFields(); 
						this.Search(false); 
						this.GetRecord(0, res.data.item); 
					}
				})
				.catch((err) => console.warn(err));
		},
		saveVotes() 
		{
			this.Workflow.votes = this.currentVotes;
			this.upsertWorkflowVotesForm = false;
		},
		clearVotes() 
		{
			this.currentVotes = [];
		},
		closeupsertWorkflowDialog() 
		{
			this.Workflow = {
				nameEn: "",
				nameAr: "", 
				availableForAll:false,
				categories:"",
			};
			this.upsertWorkflowDialogMode = "new";
			this.upsertWorkflowDialog = false;
		},
		getAllPurposes() 
		{
			this.purposes = [];
			axios.get(constants.baseApiUrl + "Document/get-all-purposes", { headers: constants.headers })
				.then((res) => 
				{
					if (res.data != null)
						this.purposes = res.data
				})
				.catch((err) => console.warn(err));
		},
		pageIndexChanged(pagingData)
		 {
			this.pagingData.pageSize = pagingData.pageSize;
			this.pagingData.pageIndex = pagingData.pageIndex;
			this.Search(false, true, pagingData.pageIndex, pagingData.pageSize);
		},
		StepsCloseupsertWorkflowDialog() 
		{
			this.Steps_clearInputs();
			this.upsertWorkflowStepsForm = false;
			this.ShowSaveSteps = false;
			this.ShowAddSteps = true;
		},
		StepsPageIndexChanged(pagingData) 
		{
			this.StepsPagingData.pageSize = pagingData.pageSize;
			this.StepsPagingData.pageIndex = pagingData.pageIndex;
			this.BindSteps(0, false, true, this.StepsPagingData.pageIndex, this.StepsPagingData.pageSize);
		},
		Steps_clearInputs() 
		{
			this.rejectStep = {};
			this.advanceStep = {};
			this.purpose = {};
			this.WorkflowStep.userId = null;
			this.WorkflowStep.purposeId = null;
			this.WorkflowStep.custom = "";
			this.WorkflowStep.canTransfer = false;
			this.WorkflowStep.canVote = false;
			this.WorkflowStep.canSeeVotingResults = false;
			this.WorkflowStep.canSign = false;
			this.WorkflowStep.isStart = false;
			this.WorkflowStep.completeAndEndAfterAdvance = false;
			this.WorkflowStep.archiveAndEndAfterAdvance = false;
			this.WorkflowStep.completeAndEndAfterReject = false;
			this.WorkflowStep.archiveAndEndAfterReject = false;
			this.WorkflowStep.name = "";
			this.WorkflowStep.workflowId = null;
			this.ToUser_TO = { type: Array, default: [] };
			this.ToUser_CC = { type: Array, default: [] };
			this.CustomCC = [{ id: 0, name: "" }];
			this.CustomTO = [{ id: 0, name: "" }];
			this.percentager = 0;
			this.groupEntityTo = "";
			this.groupEntityCC = "";
			this.to.custom = false;
			this.to.group = false;
			this.cc.custom = false;
			this.cc.group = false;
		},
		Steps_Add() 
		{
			this.upsertWorkflowStepsForm = true;
			this.Steps_clearInputs();
			this.ShowAddSteps = false;
			this.ShowSaveSteps = true;
			this.WorkflowStep = {};
			this.ArrangeAdvanced_Reject_Selects(); 
		},
		Steps_GetRecord(id) 
		{
			this.Steps_clearInputs();
			axios.get(constants.baseApiUrl + `Workflow/Steps/GetWorkflowStep/${id}`)
				.then((res) => 
				{
					this.WorkflowStep = res.data;
					console.log(res.data)
					console.log(this.WorkflowStep)
					this.purpose = this.purposes.find((x) => x.id == res.data.purposeId);
					this.rejectStep = this.steps.find((x) => x.id == res.data.rejectStepId);
					this.advanceStep = this.steps.find((x) => x.id == res.data.advanceStepId);
					if (res.data.advanceStepId == null)
						this.advanceStep = { id: 0, name: "" };
					if (res.data.rejectStepId == null)
						this.rejectStep = { id: 0, name: "" };

					let CustomArrItems_CC = res.data.customCC.split(",");
					this.CustomCC = CustomArrItems_CC.length != undefined && CustomArrItems_CC.length > 0 
							? [ { id: 0, name: "" }, ...this.CustomItems.filter((obj) => CustomArrItems_CC.includes(obj.id) ), ] : [];
					if (res.data.customCC != undefined && res.data.customCC!="" )this.cc.custom=true;
					let CustomArrItems_TO = res.data.customTO.split(",");
					this.CustomTO =
						CustomArrItems_TO.length != undefined &&
						CustomArrItems_TO.length > 0
							? [{ id: 0, name: "" }, ...this.CustomItems.filter((obj) => CustomArrItems_TO.includes(obj.id))]
							: [];
					if (res.data.customTO.length != undefined && res.data.customTO != "") this.to.custom = true;

					this.ToUser_CC = this.handleSelectElement(res.data.ccUsersStructures, { name: "temp", isTemp: true });

					if (this.ToUser_CC.length != undefined && this.ToUser_CC.length > 0)
						this.cc.user = true;

					this.percentager = res.data.percentager;
					this.groupEntites.map((ob)=> 
					{
						if (ob.name == res.data.ccGroupValue) { this.groupEntityCC = ob }
						if (ob.name == res.data.toGroupValue) { this.groupEntityTo = ob }
					});

					if (res.data.ccGroupValue != undefined && res.data.ccGroupValue .length > 0) this.cc.group = true;
					if (res.data.toGroupValue != undefined && res.data.toGroupValue .length > 0) this.to.group = true;
					this.completionCriteriaOptions.map((ob)=>
					{
						if(ob.name == res.data.completionCriteria) { this.completionCriteria = ob }
						if(ob.name == res.data.completionCriteria) { this.completionCriteria = ob }
					});

					this.ToUser_TO = this.handleSelectElement(res.data.toUsersStructures, { name: "temp", isTemp: true }); 
					if (this.ToUser_TO.length != undefined && this.ToUser_TO.length > 0) this.to.user = true; 
					this.Advance_CompleteEndCheckBox = res.data.completeAndEndAfterAdvance == true;
					this.Advance_ArchiveEndCheckBox = res.data.archiveAndEndAfterAdvance == true; 
					this.Reject_CompleteEndCheckBox = res.data.completeAndEndAfterReject == true;
					this.Reject_ArchiveEndCheckBox = res.data.archiveAndEndAfterReject == true; 
					this.upsertWorkflowStepsForm = true;
					this.ShowSaveSteps = true;
					this.ShowAddSteps = false;
					this.ArrangeAdvanced_Reject_Selects();
					this.FixSelectLabel_CC();
					this.FixSelectLabel_TO();
				})
				.catch((err) => console.warn(err));
		},
		Steps_Delete(id) 
		{
			axios.delete(constants.baseApiUrl + `Workflow/Steps/DeleteWorkflowStep/${id}`)
				.then((res) => 
				{
					window.showAlert(this.$t("res_Msgs_FilingOrClassificationDeleted"), "success");
					this.BindSteps(this.Workflow.id, false);
				})
				.catch((err) => console.warn(err));
		},
		Steps_upsert() 
		{
			let isFormValid = true;
			if (this.percentager > 100)
			{
				window.showAlert(this.$t("res_Msgs_Percentage"), "warning");
				return
			}

			isFormValid = this.Workflow.id > 0 && this.WorkflowStep.name != "" &&
				(true || (this.WorkflowStep.userId != null && parseInt(this.WorkflowStep.userId) > 0)) && this.purpose.id > 0;

			if (isFormValid == false) 
			{
				window.showAlert(this.$t("res_Msgs_FillRequired"), "warning");
				return;
			}

			this.WorkflowStep.purposeId = this.purpose.id;
			this.WorkflowStep.rejectStepId = this.rejectStep == undefined || this.rejectStep.id == undefined || this.rejectStep.id == 0 ? null : this.rejectStep.id
			this.WorkflowStep.advanceStepId = this.advanceStep == undefined || this.advanceStep.id == undefined || this.advanceStep.id == 0 ? null : this.advanceStep.id
			this.WorkflowStep.workflowId = this.Workflow.id;
			this.WorkflowStep.customCC =
				this.CustomCC.length == undefined || this.CustomCC.length == 0 ? "" : this.CustomCC.filter((item) => item.id != "0").map((item) => item.id).join(",")

			this.WorkflowStep.customTO =
				this.CustomTO.length == undefined || this.CustomTO.length == 0 ? "" : this.CustomTO.filter((item) => item.id != "0").map((item) => item.id).join(",")
 
		    this.WorkflowStep.userStructureCC = this.ToUser_CC.length == undefined ? "" : this.ToUser_CC.filter((item) => item.id != "" && item.id != undefined && item.id != null).map((item) => item.id).join(","); 
	   		this.WorkflowStep.userStructureTO = this.ToUser_TO.length == undefined ? "" : this.ToUser_TO.filter((item) => item.id != "" && item.id != undefined && item.id != null).map((item) => item.id).join(",");
		  	this.WorkflowStep.percentager =
				this.percentager ==  undefined || this.percentager== 0 ? null : this.percentager

			this.WorkflowStep.ccGroupValue =
				this.groupEntityCC ==  undefined || this.groupEntityCC== "" ? null : this.groupEntityCC.name
			this.WorkflowStep.toGroupValue =
			this.groupEntityTo ==  undefined || this.groupEntityTo== "" ? null : this.groupEntityTo.name
			this.WorkflowStep.completionCriteria = 
			this.completionCriteria ==  undefined || this.completionCriteria== "" ? null : this.completionCriteria.name

			this.WorkflowStep.completeAndEndAfterAdvance = this.radioGroupValueAfterAdvance == 1 && this.Advance_CompleteEndCheckBox == true;
			this.WorkflowStep.archiveAndEndAfterAdvance = this.radioGroupValueAfterAdvance == 2  && this.Advance_ArchiveEndCheckBox == true;
			this.WorkflowStep.completeAndEndAfterReject = this.radioGroupValueAfterReject == 1  && this.Reject_CompleteEndCheckBox == true;
			this.WorkflowStep.archiveAndEndAfterReject = this.radioGroupValueAfterReject == 2  && this.Reject_ArchiveEndCheckBox == true;
 
			axios.post(constants.baseApiUrl + "Workflow/Steps/SaveWorkflowStep", this.WorkflowStep)
				.then((res) => 
				{
					if (res.data && res.data.success == true) 
					{
						window.showAlert(this.$t("res_Msgs_SuccessfullySaved"), "success");
						this.upsertWorkflowStepsForm = false;
						this.Steps_clearInputs();
						this.BindSteps(this.Workflow.id, false);
						this.StepsCloseupsertWorkflowDialog();
					}
				})
				.catch((err) => console.warn(err));
		},
		BindStepFormData(obj) 
		{
			const data = [...obj]
			//check if there is a start activity step in order to disable the related checkbox
			this.disabledIsStart =
				data != null &&
				data.length > 0 &&
				data.some((item) => item.isStart == true);

			//bind the steps in order to use them in Advance/Reject steps selects
			if (data != null && data.length > 0) 
			{
				this.steps = data.map((item) => ({id: item.id, name: item.name }));
				this.advanceSteps = data.map((item) => ({id: item.id, name: item.name }));
				this.advanceSteps = [{ id: 0, name: "---" }, ...this.advanceSteps ];
				this.rejectSteps = data.map((item) => ({id: item.id, name: item.name }));
				this.rejectSteps = [{ id: 0, name: "---" }, ...this.rejectSteps ];
				this.disabledAdvanceSteps = false;
				this.disabledRejectSteps = false;
			} 
			else 
			{
				this.disabledAdvanceSteps = true;
				this.disabledRejectSteps = true;
			}
		},
		ArrangeAdvanced_Reject_Selects() 
		{
			//remove the selected step id  from steps reject
			let SelectedItemId =
				this.advanceStep == undefined ||
				this.advanceStep.id == undefined
					? -1
					: this.advanceStep.id; // to avoid creating loop
			this.rejectSteps = this.steps
				.filter(
					(step) =>
						(this.WorkflowStep.id == undefined ||
							step.id !== this.WorkflowStep.id) &&
						(SelectedItemId == 0 || step.id != SelectedItemId)
				)
				.map(({ id, name }) => ({ id, name }));
			this.rejectSteps = [{ id: 0, name: "---" }, ...this.rejectSteps];
			//remove the selected step id  from steps advance
			SelectedItemId =
				this.rejectStep == undefined || this.rejectStep.id == undefined
					? -1
					: this.rejectStep.id; // to avoid creating loop
			this.advanceSteps = this.steps
				.filter(
					(step) =>
						(this.WorkflowStep.id == undefined ||
							step.id !== this.WorkflowStep.id) &&
						(SelectedItemId == 0 || step.id != SelectedItemId)
				)
				.map(({ id, name }) => ({ id, name }));
			this.advanceSteps = [{ id: 0, name: "---" }, ...this.advanceSteps];
		},
		FixSelectLabel_CC() 
		{
			if (this.ToUser_CC.length == undefined || this.ToUser_CC.length == 0)
				this.CCUser_DivClass = " StructureUserDiv";
			else
				this.CCUser_DivClass = "";
		},
		FixSelectLabel_TO()
		{
			if (this.ToUser_TO.length == undefined || this.ToUser_TO.length == 0)
				this.ToUser_DivClass = " StructureUserDiv";
			else
				this.ToUser_DivClass = "";
		}, 
        populateCategories() 
		{
            this.categoriesForSelection = Object.values(constants.categories_Helper_Enum)
                .filter(item => typeof item === 'object')
                .map(item => ({ id: item.value, name: this.$t(item.text) }));
        }
	}, 
	mounted: function () { 
		this.populateCategories();
		this.cancelFormClass =
			localStorage.getItem("lang") == "ar"
				? "light-blue mr-2 btn-sm"
				: "light-blue ml-2 btn-sm";
		this.Strucutreslbl = this.$t("res_Label_Strucutres");
		this.Userlbl = this.$t("res_Label_User");
		this.Customlbl = this.$t("res_Label_Custom");
		this.contactRoles = constants.contactRoles;
		this.privacies = constants.privacies;
		this.getAllPurposes();

		this.Search(true);
		this.getEntitiesGroup();
	},
	  watch: {
        Advance_CompleteEndCheckBox(newVal) {
            if (newVal) {
                this.Advance_ArchiveEndCheckBox = false;
            }
        },
        Advance_ArchiveEndCheckBox(newVal) {
            if (newVal) {
                this.Advance_CompleteEndCheckBox = false;
            }
        },
		 Reject_CompleteEndCheckBox(newVal) {
            if (newVal) {
                this.Reject_ArchiveEndCheckBox = false;
            }
        },
        Reject_ArchiveEndCheckBox(newVal) {
            if (newVal) {
                this.Reject_CompleteEndCheckBox = false;
            }
        }
    }
};
</script>

<style>    
	#ManageWorkflow-CategoryDiv .multiselect__content-wrapper { position: fixed; width: 250px; }
	#VotesFormTitleDiv { padding: 0px 1rem  5px 1rem; }
	#votesContainer { max-height: 300px; overflow-y: auto; }
	#votesContainer .v-text-field  { margin: 0.2rem 0.5rem; }
	.VotesForm { width: 120vh; max-height: 50vh; }
	.smaller-dialog { max-height: 300px !important; } 
	.To_CC_Select_Div .v-select__slot .v-label.theme--light { margin-left: 0.5rem !important; color: var(--palceholder-color) !important; }
	.StructureUserDiv .multiselect__tags .multiselect__placeholder { display: none !important; }
	.StructureUserDiv .multiselect__tags input { width: 100% !important; padding-left: 14px !important; }
	.StructureUserDiv .multiselect__tags input::placeholder { color: var(--palceholder-color) !important; }
</style>

<style scoped>
.v-input--selection-controls__input { padding-top: 5rem !important; }
.StepsDiv { margin: 1rem 1rem 0rem 1rem; }

.vtooltip {
	background-color: white;
	padding: 5px;
	border-radius: 25px;
}

.report-container .v-input--selection-controls {
	margin-top: 0;
	padding-top: 0;
}

.report_header {
	height: 50px;
	vertical-align: middle;
	font-weight: 500;
	font-size: 12px;
	letter-spacing: 0.015em;
	color: #667593;
}

.report-container .theme--light.v-data-table.v-data-table--fixed-header thead th,
.report-container .v-data-table__wrapper table thead {
	background-color: #fff;
	box-shadow: none;
}

.report-container {
	height: calc(100vh - 116px);
	display: flex;
	flex-direction: column;
	border-radius: 12px !important;
	overflow: auto;
	box-shadow: none !important;
}

.report-container .border-top { display: flex; flex-direction: column; }
.report-container .v-toolbar { height: 80px !important; padding: 0; }
.report-container .v-toolbar__content { height: 100% !important; padding: 24px !important; }
img#ItemPreview { width: 100px; margin: 0.5rem 0; }

.mdi-menu-down {
  	filter: brightness(0) saturate(100%) invert(39%) sepia(56%) saturate(232%)
    hue-rotate(182deg) brightness(102%) contrast(83%) !important;
}

.v-dialog .v-toolbar__content { height: 100% !important; }
.percentager{ margin-top: 4rem !important; }
</style>